import React from 'react';
const HtmlView = ({ html, className, refProp }) => {
    return (React.createElement("div", { ref: refProp, dangerouslySetInnerHTML: { __html: html }, className: 'last-child-mb-0 clearfix ' + (className ? className : '') }));
};
export { HtmlView };
//# sourceMappingURL=HtmlView.js.map